import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/AnueTopBar/DesktopTopBar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/atoms/InteractingObserverGtm/InteractingObserverGtm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/atoms/RwdAdSlot/RwdAdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/BreadCrumb/BreadCrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/JoeWallStreetColumn/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/KeywordAdBanner/KeywordAdBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/KeywordAdText/KeywordAdText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/NewsCoverImage/NewsCoverImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/molecules/NewsCoverVideo/NewsCoverVideo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/NewsDetail/AddAlreadyView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DownloadAppLink"] */ "/opt/app/apps/fe-news/components/NewsDetail/DownloadAppLink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/DownloadAppList.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/NewsContent.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/NewsDetail/NewsTags/FolderContainer.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/PreviousNextNews.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/ColumnistsAuthor.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/NewsTags/NewsTags.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/app/(main)/news/id/[id]/page.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/NewsDetail/ReadMore/ReadMoreLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/NewsDetail/RelatedProducts/FolderContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/NewsDetail/RelatedProducts/RelatedProductsSection.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/organisms/NewsCoverImageOrVideo/NewsCoverImageOrVideo.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/ReadMore/index.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/RelatedProducts/RelatedProducts.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/RelatedWarrants/RelatedWarrants.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CryptoPromotion","DynamicLoadHaoAndComment"] */ "/opt/app/apps/fe-news/components/templates/DynamicLoad/NewsDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/apps/fe-news/components/templates/DynamicLoad/SubDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Button/theme/Anue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Button/theme/Folder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Button/theme/NewsLabel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Button/theme/NewsTag.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/LinkButton/Account.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/libs/fe-common-ui/src/LinkButton/Anue.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/LinkButton/Buy/Buy.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/libs/fe-common-ui/src/LinkButton/News.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/LinkButton/Stock.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/libs/fe-common-ui/src/LinkButton/Tag.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Quote/Quote.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/ReadMore/ReadMore.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/libs/fe-common-ui/src/Section/Section.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/opt/app/apps/fe-news/components/NewsDetail/WinIndicator.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-common-ui/src/Slider/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","WinIndicatorStock"] */ "/opt/app/libs/fe-common-ui/src/WinIndicator/WinIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AD_EMPTY_EVENT","AD_RENDERED_EVENT","default"] */ "/opt/app/libs/fe-dfp/src/lib/adslot/adslot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/app/libs/fe-dfp/src/lib/dynamicAdslot/dynamicAdslot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Initialize"] */ "/opt/app/libs/fe-dfp/src/lib/initialize/initialize.tsx");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.5_react-dom@18.3.0_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.5_react-dom@18.3.0_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.5_react-dom@18.3.0_react@18.3.1__react@18.3.1_sass@1.77.6/node_modules/next/dist/client/script.js");
